import { axiosClient } from 'www/utils'

/**
 * @description Запрос на создание WS для подтверждения номера по звонку
 *
 * @param {object} options -
 * @param {string} options.phone -
 *
 * @returns { Promise } -
 */

function requestCallConfirmationStart({ phone }) {
  return axiosClient.post(
    `${window.MEDTOCHKA_URL}/services/sso/calls/create_request/`,
    {
      phone,
    },
    {
      withCredentials: true,
    },
  )
}

export default requestCallConfirmationStart
